import TestimonialV2 from './testimonialv2'

export default TestimonialV2
